import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <footer className="relative glass-card border-t border-gray-200/50 dark:border-gray-700/50 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
            <span>Made with the</span>
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              <Heart className="w-3.5 h-3.5 text-red-500 fill-current" />
            </motion.div>
            <span>of God by</span>
            <a
              href="https://github.com/Benzsoft/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 transition-colors font-medium"
            >
              Rubbens
            </a>
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
            <span>© 2025 Verse4All</span>
            <Link to="/landing" className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors">Landing</Link>
            <Link to="/privacy" className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}